import { render, staticRenderFns } from "./photographDetail.vue?vue&type=template&id=c9427b08&scoped=true&"
import script from "./photographDetail.vue?vue&type=script&lang=js&"
export * from "./photographDetail.vue?vue&type=script&lang=js&"
import style0 from "./photographDetail.vue?vue&type=style&index=0&id=c9427b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9427b08",
  null
  
)

export default component.exports